export default "__VITE_ASSET__CzVLDYUu__"